<template>
  <div>
    <v-row>
      <v-col cols="12" class="my-auto">
        <div style="font-size: 17px" class="indigo--text font-weight-medium">Laporan Tindak Lanjut</div>
        <div class="caption grey--text">
          <em>
            Silahkan melengkapi laporan dengan mengisikan
            <span class="font-weight-medium grey--text text--darken-1">minimal 1 Topik Permasalahan</span>
          </em>
        </div>
      </v-col>
    </v-row>
    <v-list class="orange lighten-5">
      <v-list-item v-for="id in maxLaporan" :key="id" class="px-0">
        <v-list-item-content>
          <v-row>
            <v-col cols="12" lg="6" class="my-auto">
              <span class="body-1 indigo--text ml-3">Topik Permasalahan {{ id }}</span>
              <div v-if="topiksLaporan[id - 1]" class="ml-3">
                <div class="body-2">
                  <span class="font-weight-medium">Topik: </span>
                  {{ $getDeepObj(topiksLaporan[id - 1], 'm_kp_topik_psp.data.keterangan') }}
                </div>
                <div class="body-2">
                  <span class="font-weight-medium">Subtopik: </span>
                  {{ $getDeepObj(topiksLaporan[id - 1], 'm_kp_subtopik_psp.data.keterangan') }}
                </div>
                <div class="body-2">
                  <span class="font-weight-medium">Status: </span>
                  <span
                    :class="[`${colorStatusProgres[$getDeepObj(topiksLaporan[id - 1], 'k_progres_psp') || 0]}--text`]"
                  >
                    {{
                      $getDeepObj(topiksLaporan[id - 1], 'm_kp_opsi_psp_progres_psp.data.keterangan') ||
                        'Belum ditentukan'
                    }}
                  </span>
                </div>
              </div>
            </v-col>
            <v-col cols="12" lg="3" class="my-auto">
              <div class="body-2 grey--text">Status Laporan</div>
              <v-chip class="white--text" :color="getStatus(id, 'color')">{{ getStatus(id, 'label') }}</v-chip>
            </v-col>
            <v-col
              v-if="
                (isEdit && isPeriodeEntry) ||
                  (!isEdit && getStatus(id, 'value')) ||
                  (!isPeriodeEntry && getStatus(id, 'value'))
              "
              cols="12"
              lg="3"
              class="my-auto"
            >
              <div :class="['orange--text text--lighten-5']">Aksi</div>
              <v-btn
                :color="!getStatus(id, 'value') ? 'success' : 'primary'"
                depressed
                class="text-capitalize"
                @click="onEntryLaporan(id)"
              >
                <v-icon left class="mr-1">
                  {{ !isEdit ? 'mdi-eye' : !getStatus(id, 'value') ? 'mdi-plus' : 'mdi-pencil' }}
                </v-icon>
                {{
                  !isEdit
                    ? 'Lihat'
                    : !getStatus(id, 'value')
                    ? 'Tambah'
                    : getStatus(id, 'value') === 1
                    ? 'Lengkapi'
                    : 'Ubah'
                }}
                Laporan
              </v-btn>
            </v-col>
          </v-row>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <base-modal-full
      ref="modal"
      title="Laporan Tindak Lanjut"
      :useSave="isEdit && !formulir.isPreview"
      @save="onSaveLaporan"
    >
      <form-topik
        ref="formulir"
        :masters="Object.assign({}, masters)"
        :id="formulir.id"
        :laporan="formulir.laporan"
        :detail="detail"
        :is-preview="formulir.isPreview"
        :is-entry="isPeriodeEntry"
        :pelaksana="pelaksana"
        :pendampingan-ke="pendampinganKe"
        @refresh="onRefresh"
      />
    </base-modal-full>
  </div>
</template>
<script>
import FormTopik from '../forms/FormTopik.vue';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'LaporanTopik',
  components: { FormTopik },
  props: {
    isEdit: {
      type: Boolean,
      default: true,
    },
    pelaksana: {
      type: Object,
      default: () => {},
    },
    meta: {
      type: Object,
      default: () => {},
    },
    pspKpPa: {
      type: Object,
      default: () => {},
    },
    pendampinganKe: {
      type: [Number, String],
      default: '',
    },
    pspKpPaId: {
      type: [Number, String],
      default: '',
    },
    detail: {
      type: Object,
      default: () => {},
    },
    masters: {
      type: Object,
      default: () => {},
    },
    isLoginKs: {
      type: Boolean,
      default: true,
    },
    isPeriodeEntry: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      maxLaporan: 2,
      formulir: {},
      colorStatusProgres: {
        0: 'orange',
        71: 'green',
        72: 'blue',
        73: 'orange',
        74: 'red',
      },
    };
  },
  computed: {
    ...mapState('preferensi', {
      configPendampingan: (state) => (state.data && state.data.pendampingan && state.data.pendampingan['kp-pa']) || {},
    }),

    topiksLaporan() {
      return this.$getDeepObj(this.detail, 'psp_kp_pa_sekolah_laporan_topiks.data') || [];
    },
  },
  methods: {
    ...mapActions('laporan', ['save']),

    getStatus(id, type) {
      let status = { label: 'Tidak ada', color: 'orange', value: 0 };

      if (!this.topiksLaporan[id - 1]) {
        return status[type];
      }

      const statusLengkap = this.$getDeepObj(this.detail, 'status_lengkap') || {};
      if (!this.$isObject(statusLengkap) && this.topiksLaporan[id - 1]) {
        status = { label: 'Lengkap', color: 'green', value: 2 };
      } else if (statusLengkap[`topik-${id}`]) {
        status = { label: 'Lengkap', color: 'green', value: 2 };
      } else {
        status = { label: 'Dalam pengerjaan', color: 'blue', value: 1 };
      }

      return status[type];
    },

    onEntryLaporan(id) {
      if (!this.topiksLaporan[id - 1]) {
        this.onAddLaporan(id);
        return;
      }

      this.onEditLaporan(id);
    },

    onRefresh() {
      this.$emit('reload', this.meta?.sekolah ?? {}, { reset: true });
    },

    onAddLaporan(id) {
      this.$set(this.formulir, 'id', id);
      this.$set(this.formulir, 'laporan', {});
      this.$set(this.formulir, 'topikId', null);
      this.$set(this.formulir, 'isPreview', !this.isEdit);

      this.$refs.modal.open();
      this.$nextTick(() => {
        this.$refs.formulir.reset();
      });
    },

    onEditLaporan(id) {
      const laporan = this.topiksLaporan[id - 1];

      this.$set(this.formulir, 'id', id);
      this.$set(this.formulir, 'laporan', laporan);
      this.$set(this.formulir, 'topikId', laporan.psp_kp_pa_sekolah_laporan_topik_id);
      this.$set(this.formulir, 'isPreview', !this.isEdit);

      this.$refs.modal.open();
      this.$nextTick(() => {
        this.$refs.formulir.reset();
      });
    },

    onSaveLaporan() {
      const topikId = this.formulir.topikId || '';
      const params = Object.assign({ pendampingan_ke: this.pendampinganKe }, this.$refs.formulir.getValue());

      let endpoint = `pendampingan-ks/${this.pspKpPa.psp_kp_pa_id}/pelaksana/${this.pelaksana.psp_pelaksana_id}/create-topik`;
      if (topikId) {
        endpoint = `pendampingan-ks/${this.pspKpPa.psp_kp_pa_id}/pelaksana/${this.pelaksana.psp_pelaksana_id}/update-topik/${topikId}`;
      }

      if (!this.isLoginKs) {
        const pspKpPaPendampinganId = this.meta.psp_kp_pa_pendampingan_id;
        const pspKpPaSekolahId = this.meta.psp_kp_pa_sekolah_id;

        endpoint = `pendampingan-pa/${pspKpPaPendampinganId}/topik/${pspKpPaSekolahId}/create`;
        if (topikId) {
          endpoint = `pendampingan-pa/${pspKpPaPendampinganId}/topik/${pspKpPaSekolahId}/${topikId}/update`;
        }
      }

      this.save({ endpoint, params })
        .then(() => {
          this.onRefresh();
          this.$success('Laporan berhasil disimpan');
          this.$refs.modal.dialog = false;
        })
        .catch(() => {
          this.$refs.modal.loading = false;
        });
    },
  },
};
</script>

<style scoped></style>
